import { forwardRef } from 'react';
import styled from 'styled-components';

//* HOC's
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

//* Components
import Translate from '../Translate';

const Wrapper = styled.p``;

const Text = forwardRef((props, ref) => {
	let string = (
		<Translate
			val={props.text}
			vars={props.vars}
		/>
	);

	return (
		<Wrapper
			ref={ref}
			as={props.tag}
			data={props.data}
			style={props.style}
			onClick={props.onClick || null}
			className={`comp_title ${props.uppercase ? 'uppercase' : ''} ${props.className || ''}`}
			{...props.attr}>
			{props.children || string}
		</Wrapper>
	);
});

Text.displayName = 'Text';

export default withLanguageContext(Text, ['translate']);
